'use client';
import React from 'react';
import Slider from 'react-slick';

const TechnicalApproachDataEngineering: React.FC = () => {
    const technicalapproach = {
        dots: true,
        arrow: true,
        autoplay: false,
        speed: 500, // Set slide transition speed
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
            breakpoint: 1366,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <>
            <section className="section-py case-study relative overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <video playsInline autoPlay muted loop className="aimlvideo w-full h-full object-cover">
                        <source src="media/video-data-engineering-foundations.mp4" type="video/mp4" />
                    </video>
                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 pointer-events-none bg-video-gradient"></div>
                </div>
                <div className="container lg:container md:mx-auto relative z-[1]">
                    <div className="row grid lg:grid-cols-12 mb-50">
                        <div className="lg:col-span-10">
                            <h2 className="mb-2.5 text-white">
                                How We Build: <span className="gradient-text">Our Technical Approach</span>
                            </h2>
                            <p className="mb-0 fw-600 text-[#D7DEE5]">
                                We follow a structured technical approach to build robust data foundations.
                            </p>
                        </div>
                    </div>

                    <div className="section pb-16 case-study-slider-img case-study-slider-aiml technical-approach-slider aienabled-fintech-slider">
                        <div className="container-fluid lg:container-fluid mx-auto">
                            <Slider {...technicalapproach} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-discovery-design bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Discovery & Current State Analysis
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    Assess existing data sources, systems, data volumes, quality issues, performance bottlenecks, compliance requirements, and business analytics needs.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-data-preparation bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Architecture Design
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    Define target data architecture (warehouse, lake, lakehouse), select the technology stack, design data flow patterns, security controls, and scalability aligned with business goals.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-rag-architecture bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                   Data Modeling & Schema Design
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    Create logical and physical data models, dimensional models for analytics, and define normalization, partitioning, and indexing strategies.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-prompt-engineering bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Pipeline Development
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    Develop ETL/ELT pipelines with error handling, data validation, transformation logic, incremental loading, and orchestration monitoring.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-fine-tuning bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Data Quality Implementation
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    Deploy validation rules, anomaly detection, data profiling, quality scoring, alerting mechanisms, and automated remediation workflows.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-integration-testing bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Infrastructure Setup
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                   Provision cloud resources, configure data platforms, implement security controls, set up networking, establish backup/recovery, and optimize costs.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-integration-testing bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Testing & Validation
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                   Perform data reconciliation, load and performance testing, failover scenarios, quality checks, and end-to-end pipeline validation.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-integration-testing bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Deployment & Monitoring
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                   Execute staged production rollout with continuous monitoring, alerting dashboards, performance metrics, cost tracking, and operational documentation.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default TechnicalApproachDataEngineering;
